/**
 * ContainerModel — 容器视图模型（一切皆 Model，cb 源码模式）
 *
 * 所有控件模型扁平存储在 rootVM._data 上，key = cItemName || field。
 * viewmodel.get("field1") 直接返回 SimpleModel 实例。
 */
ttx.models.register('ContainerModel', function (modelType) {

    var containerModel = function (data) {
        ttx.models.BaseModel.call(this, data);
    };
    containerModel.prototype = ttx.utils.getPrototype(ttx.models.BaseModel.prototype);
    containerModel.prototype.modelType = modelType;

    // ======== 存储 & 读取 ========

    containerModel.prototype.set = function (name, value) {
        if (value instanceof ttx.models.BaseModel) {
            value.setParent(this);
            value.setName(name);
            if (typeof value.afterInit === 'function') value.afterInit();
        }
        this._set_data(name, value, true);
    };

    containerModel.prototype.get = function (name) {
        // 优先返回控件模型（缓存域分离），兜底返回 _data 原始属性
        var fieldModels = this.getCache('$ctrl');
        if (fieldModels && fieldModels[name] !== undefined) return fieldModels[name];
        var model = this._get_data(name);
        if (model instanceof ttx.models.BaseModel &&
            model.get('bSelfDefine') && model.get('depend') && model.get('characterKey') &&
            (model.get('cControlType') || '').toLocaleLowerCase() !== 'character') {
            var dm = this.get(model.get('depend'));
            var cm = dm && dm.get && dm.get(model.get('characterKey'));
            if (cm) model = cm;
        }
        return model;
    };

    containerModel.prototype.updateListenerState = function () {};

    containerModel.prototype.addProperty = function (name, value) {
        var p = this.get(name);
        if (p && typeof p.setData === 'function') { p.setData(value); return; }
        var dk = this._get_data('domainKey') || (this._get_data('params') || {}).domainKey;
        if (dk && value instanceof ttx.models.BaseModel && !value._get_data('domainKey'))
            value._set_data('domainKey', dk);
        this.set(name, value);
    };

    containerModel.prototype.setData = function (data, noRender) {
        if (!data || typeof data !== 'object') return;
        for (var k in data) { if (data.hasOwnProperty(k)) this.addProperty(k, data[k]); }
    };

    // ======== 视图元数据 → 模型 ========

    /** 递归遍历容器，为所有控件创建模型（包括 Toolbar 按钮，标记 needCollect:false 不进 getData） */
    function _recursiveContainer(container, viewMeta, viewModel) {
        var code = container.cGroupCode || container.groupId || container.key;
        if (!code) return;
        if (viewMeta[code]) return;
        viewMeta[code] = container;
        (container.controls || []).forEach(function (ctrl) {
            var key = ctrl.cItemName || ctrl.field;
            var fieldModels = viewModel.getCache('$ctrl') || {};
            if (key && fieldModels[key] === undefined) viewModel.setControlFieldModel(ctrl);
        });
        (container.containers || []).forEach(function (ch) {
            _recursiveContainer(ch, viewMeta, viewModel);
        });
    }

    containerModel.prototype.setViewMeta = function (meta) {
        if (!meta || !meta.containers || !meta.containers.length) return;
        this._set_data('viewmeta', meta, true);
        var vm = {};
        var self = this;
        meta.containers.forEach(function (c) { _recursiveContainer(c, vm, self); });
        this.setCache('viewMeta', vm);
    };

    containerModel.prototype.getViewMeta = function (code) {
        var vm = this.getCache('viewMeta');
        return vm ? ttx.utils.extend(true, {}, vm[code]) : undefined;
    };

    // ======== 控件 → 模型 ========

    /** 按 cControlType 创建对应 Model（参照 cb 源码 dispatch，控件元数据标记 needCollect:false） */
    containerModel.prototype.setControlFieldModel = function (control) {
        if (!control) return null;
        var cType = (control.cControlType || control.ctrlType || '').trim().toLocaleLowerCase();
        var key = control.cItemName || control.field;
        if (!key) return null;

        var model;
        if (control.extModelType && ttx.models[control.extModelType]) {
            model = new ttx.models[control.extModelType](
                ttx.utils.extend(true, {}, { domainKey: (this.getParams && this.getParams() || {}).domainKey }, control)
            );
        } else {
            switch (cType) {
                case 'table':
                    model = new ttx.models.SimpleModel(ttx.utils.extend(true, { needCollect: false }, control));
                    break;
                case 'select':
                case 'radio':
                case 'checkboxenum':
                case 'optionwidget':
                    model = new ttx.models.SimpleModel(ttx.utils.extend(true, { needCollect: false }, control));
                    break;
                default:
                    // 按钮等无数据控件：needCollect=false，不参与 getData() 收集
                    model = new ttx.models.SimpleModel(
                        ttx.utils.extend(true, { needCollect: false, invalidReset: false }, control)
                    );
                    // 桥接 click 事件：让 vm.get('xxx').execute('click') 能正常工作
                    // - 有 command/systemCommand：自动路由到命令系统（系统按钮如 add/edit/save）
                    // - 无 command：不注册，保持事件系统原语义（业务方可自己 vm.get('xxx').on('click', fn)）
                    if (cType === 'button') {
                        var clickCmd = control.systemCommand || control.command;
                        if (clickCmd) {
                            model.on('click', function () {
                                ttx.command.execute(clickCmd, {
                                    vm: model.getRootParent ? model.getRootParent() : model.getParent(),
                                    code: key,
                                    button: control
                                });
                            });
                        }
                    }
                    break;
            }
        }
        var fieldModels = this.getCache('$ctrl') || {};
        model.setParent(this);
        model.setName(key);
        fieldModels[key] = model;
        this.setCache('$ctrl', fieldModels);
        return model;
    };

    // ======== 数据收集 ========

    /**
     * 收集数据（模型驱动）：
     * 1. 以 _data.value 为基础，展开表单平铺字段（Form._setFormData 写入）和已同步的子表数据（SimpleTable._setTableData 写入）
     * 2. 叠加可收集子模型（GridModel 等）的数据，带行状态 _status，用于服务端识别增删改
     * 这样避免"收集到子模型就整体丢弃 _data.value"导致表单字段丢失的问题。
     */
    containerModel.prototype.getData = function () {
        var names = this._get_data('propertyNames') || [];
        var valueData = this._get_data('value');
        var raw = {};
        var hasData = false;

        // 1. 展开 _data.value（表单平铺字段 + 已同步的子表数据）
        if (valueData && typeof valueData === 'object' && !Array.isArray(valueData)) {
            for (var k in valueData) {
                if (valueData.hasOwnProperty(k)) { raw[k] = valueData[k]; hasData = true; }
            }
        }

        // 2. 叠加可收集子模型数据（GridModel 等，带行状态 _status），按 cItemName 作为 key 与 _data.value 对齐
        for (var i = 0; i < names.length; i++) {
            var p = this.get(names[i]);
            if (!(p instanceof ttx.models.BaseModel)) continue;
            if (p._get_data('needCollect') === false) continue;
            if (p.getData) {
                // 优先用业务字段名（cItemName）作为 key，保持与 _data.value 中子表 key 一致，
                // 让 GridModel 带 _status 的数据覆盖 _data.value 中的原始数据
                var itemKey = p._get_data('cItemName') || names[i];
                raw[itemKey] = p.getData();
                hasData = true;
            }
        }

        return hasData ? raw : (valueData || raw);
    };

    containerModel.prototype.getAllData = function () {
        var names = this._get_data('propertyNames') || [];
        var raw = {};
        for (var i = 0; i < names.length; i++) {
            var p = this.get(names[i]);
            if (!(p instanceof ttx.models.BaseModel)) continue;
            if (p._get_data('needCollect') === false) continue;
            var v = p.getAllData ? p.getAllData() : p.getData();
            if (v !== undefined) raw[names[i]] = v;
        }
        return raw;
    };

    containerModel.prototype.loadData = function (data) {
        this.setCache('isLoadData', true);
        this.setData(data, true);
        this.setDirty(false);
        this.setCache('isLoadData', false);
    };

    // ======== 模型查找 ========

    containerModel.prototype.getGridModel = function () {
        var names = this._get_data('propertyNames') || [];
        for (var i = 0; i < names.length; i++) {
            var m = this.get(names[i]);
            if (m instanceof ttx.models.BaseModel && (m._get_data('cControlType') || '').toLocaleLowerCase() === 'table')
                return m;
        }
        return null;
    };

    containerModel.prototype.getGridModels = function () {
        var names = this._get_data('propertyNames') || [];
        var r = [];
        for (var i = 0; i < names.length; i++) {
            var m = this.get(names[i]);
            if (m instanceof ttx.models.BaseModel && (m._get_data('cControlType') || '').toLocaleLowerCase() === 'table')
                r.push(m);
        }
        return r;
    };

    containerModel.prototype.getTreeModel = function () {
        var names = this._get_data('propertyNames') || [];
        for (var i = 0; i < names.length; i++) {
            var m = this.get(names[i]);
            var t = (m._get_data('cControlType') || '').toLocaleLowerCase();
            if (m instanceof ttx.models.BaseModel && (t === 'searchtree' || t === 'tree')) return m;
        }
        return null;
    };

    containerModel.prototype.getParams = function () { return this._get_data('params'); };
    containerModel.prototype.getDomainKey = function () {
        return (this.getParams && this.getParams() || {}).domainKey || this._get_data('domainKey');
    };

    // ======== MDF 标准 API 补齐 ========
    // 注：与现有 get/addProperty/getData/getAllData/loadData/setDirty/setReadOnly/
    //     getGridModel/getTreeModel/getParams/getDomainKey/getViewMeta 同名方法不重复定义。

    /**
     * 根据属性名移除子 model
     * @param {string} propertyName 子 model 属性名
     */
    containerModel.prototype.removeProperty = function (propertyName) {
        if (!propertyName) return;
        // 从控件缓存中移除
        var fieldModels = this.getCache('$ctrl');
        if (fieldModels && fieldModels[propertyName]) {
            delete fieldModels[propertyName];
        }
        // 从 _data 中移除
        this._del_data(propertyName);
    };

    /**
     * 获取基类 model 中初始数据
     * setDirty(false) 时会缓存 originalData，此处返回该快照
     * @returns {Object} 初始数据
     */
    containerModel.prototype.getOriginalData = function () {
        return this._get_data('originalData');
    };

    /**
     * 获取基类 model 中 bMustSelect 为 true 的数据
     * @returns {Object} 仅包含必选字段的数据
     */
    containerModel.prototype.getNecessaryData = function () {
        var names = this._get_data('propertyNames') || [];
        var raw = {};
        for (var i = 0; i < names.length; i++) {
            var p = this.get(names[i]);
            if (!(p instanceof ttx.models.BaseModel)) continue;
            if (p._get_data('needCollect') === false) continue;
            if (p._get_data('bMustSelect') === true) {
                raw[names[i]] = p.getData ? p.getData() : p.getValue ? p.getValue() : undefined;
            }
        }
        return raw;
    };

    /**
     * 表单校验：遍历所有子 model，检查必输项（bIsNull=false）
     * @returns {Boolean} 校验通过返回 true，失败返回 false
     */
    containerModel.prototype.validate = function () {
        var names = this._get_data('propertyNames') || [];
        var errors = [];
        for (var i = 0; i < names.length; i++) {
            var p = this.get(names[i]);
            if (!(p instanceof ttx.models.BaseModel)) continue;
            if (p._get_data('needCollect') === false) continue;
            // 子 model 自带 validate 方法时优先调用
            if (typeof p.validate === 'function') {
                if (!p.validate()) errors.push(names[i]);
                continue;
            }
            // 必输项校验：bIsNull=false 表示必输
            if (p._get_data('bIsNull') === false) {
                var val = p.getData ? p.getData() : p.getValue ? p.getValue() : undefined;
                if (ttx.utils.isEmpty(val)) {
                    errors.push(names[i]);
                }
            }
        }
        if (errors.length) {
            this.execute('validateError', errors);
            return false;
        }
        return true;
    };

    /**
     * 获取脏数据（差异化数据）
     * 遍历所有子 model，调用其 getDirtyData；无 getDirtyData 时与 originalData 对比
     * @returns {Object} 脏数据对象
     */
    containerModel.prototype.getDirtyData = function () {
        var names = this._get_data('propertyNames') || [];
        var raw = {};
        var hasDirty = false;
        var originalData = this._get_data('originalData') || {};
        for (var i = 0; i < names.length; i++) {
            var p = this.get(names[i]);
            if (!(p instanceof ttx.models.BaseModel)) continue;
            if (p._get_data('needCollect') === false) continue;
            if (typeof p.getDirtyData === 'function') {
                var dirty = p.getDirtyData();
                if (dirty != null && !(typeof dirty === 'object' && !ttx.utils.isArray(dirty) && ttx.utils.isEmptyObject(dirty))) {
                    raw[names[i]] = dirty;
                    hasDirty = true;
                }
            } else {
                var curVal = p.getData ? p.getData() : undefined;
                var orgVal = originalData[names[i]];
                if (JSON.stringify(curVal) !== JSON.stringify(orgVal)) {
                    raw[names[i]] = curVal;
                    hasDirty = true;
                }
            }
        }
        return hasDirty ? raw : {};
    };

    /**
     * 加载脏数据
     * @param {Object} data 脏数据对象
     */
    containerModel.prototype.loadDirtyData = function (data) {
        if (!data || typeof data !== 'object') return;
        this.setCache('isLoadData', true);
        for (var k in data) {
            if (!data.hasOwnProperty(k)) continue;
            var p = this.get(k);
            if (p instanceof ttx.models.BaseModel) {
                if (typeof p.loadDirtyData === 'function') {
                    p.loadDirtyData(data[k]);
                } else if (typeof p.setData === 'function') {
                    p.setData(data[k]);
                }
            }
        }
        this.setCache('isLoadData', false);
    };

    /**
     * 清除数据：遍历所有子 model 调用 clear
     */
    containerModel.prototype.clear = function () {
        var names = this._get_data('propertyNames') || [];
        for (var i = 0; i < names.length; i++) {
            var p = this.get(names[i]);
            if (!(p instanceof ttx.models.BaseModel)) continue;
            if (p._get_data('needCollect') === false) continue;
            if (typeof p.clear === 'function') p.clear(false);
        }
        this._set_data('value', null, true);
        this._del_data('originalData');
    };

    /**
     * 收集数据
     * @param {Boolean} all true 收集所有数据，false 只收集脏数据
     * @returns {Object} 收集到的数据对象
     */
    containerModel.prototype.collectData = function (all) {
        if (all === false) return this.getDirtyData();
        return this.getData();
    };

    /**
     * 获取当前页面模型下所有嵌入关联对象（page）模型的映射 Map
     * @returns {Map} billNo -> viewModel 的映射
     */
    containerModel.prototype.getSubPageViewModels = function () {
        // 优先从缓存获取
        var cached = this.getCache('subPageViewModels');
        if (cached) return cached;
        var result = new Map();
        var names = this._get_data('propertyNames') || [];
        for (var i = 0; i < names.length; i++) {
            var p = this.get(names[i]);
            if (!(p instanceof ttx.models.BaseModel)) continue;
            // 子 model 自身为 ContainerModel 且带有 billNo 参数时视为关联对象模型
            var pParams = (typeof p.getParams === 'function') ? p.getParams() : null;
            var billNo = pParams && (pParams.billNo || pParams.billno);
            if (billNo && typeof p.getGridModel === 'function') {
                result.set(billNo, p);
            }
        }
        this.setCache('subPageViewModels', result);
        return result;
    };

    /**
     * 根据 billNo 获取特定关联对象模型
     * @param {string} billNo 单据号
     * @returns {ContainerModel|null} 关联对象模型
     */
    containerModel.prototype.getSubPageViewModel = function (billNo) {
        if (!billNo) return null;
        var map = this.getSubPageViewModels();
        return map.get(billNo) || null;
    };

    return containerModel;
});
